import getDefaultParam from './getDefaultParam';

const getDocumentUrl = id =>
  `./weekly-check/api/${getDefaultParam('organization')}/document/${id}`;

export default getDocumentUrl;